<template>
  <div>
    <el-row style="margin-bottom:15px">
      <el-col :span="8">
        <el-button v-if="ShowBack" class="top-bottom" type="primary" @click="goBack" round>返回</el-button>
        <div style="    float: left;" v-for="(item, index) in TopButtons" :key="index">
          <el-upload v-if="item.action == 'input'" :action="uploadAction" :headers="uploadHeader" :show-file-list="false" :on-success="item.back">
            <el-button :type="item.type || 'primary'" round>{{item.name}}</el-button>
          </el-upload>
          <el-button :type="item.type || 'primary'" v-else class="top-bottom" @click="topButtonClick(item.action,item)" round>{{item.name}}</el-button>
        </div>
      </el-col>
      <el-col :span="16" :offset="TopButtons.length == 0 &&  !ShowBack? 8 : 0" v-if="TopSeach.length > 0">
        <el-row style="text-align: right;">
          <div v-for="(item, index) in TopSeach" :key="index">
            <el-col v-if="item.type != 'param'" :span="item.span || 20" class="pad">
              <div>
                <el-col :span="item.name ? 8 : 0" class="lable">{{item.name}}</el-col>
                <el-col :span="item.name ? 16 : 24">
                  <form-item :type="item.type || 'text'" :clearable="item.clearable" :form="item" :value.sync="Seach[item.param]" :select="selectOption[item.param] || []" @valueChange="changeValue" :multiple="item.multiple || false" :onlyUser="item.onlyUser || false" :placeholder="item.placeholder"></form-item>
                </el-col>
              </div>
            </el-col>
          </div>
          <el-col class="pad" :span="4">
            <el-button type="primary" icon="el-icon-search" round @click="GetList">搜索</el-button>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
    <el-row style="margin-bottom:15px">
      <el-table ref="Table" border :data="TableData" highlight-current-row show-overflow-tooltip style="width: 100%" @sort-change="sortChange">
        <el-table-column v-for="(item, index) in TableColumns" :key="index" :property="item.param" :label="item.name" :width="item.width" :sortable="item.isSort ? 'custom' : false">
          <template slot-scope="scope">
            <div v-if="item.type == 'index'">
              <span style="margin-left: 10px">{{ PageSize * (PageIndex - 1) + scope.$index + 1  }}</span>
            </div>
            <div v-else>
              <div v-if="item.action" class="table-action">
                <el-button type="text" style="margin-left: 10px;color:#409EFF;padding:0" @click="tableButtonClick(scope.row,item.action,item)" v-if="item.format">{{ item.format(scope.row[item.param]) }}</el-button>
                <el-button type="text" style="margin-left: 10px;color:#409EFF;padding:0" @click="tableButtonClick(scope.row,item.action,item)" v-else>{{ scope.row[item.param] }}</el-button>
              </div>
              <div v-else>
                <span style="margin-left: 10px" v-if="item.format">{{ item.format(scope.row[item.param]) }}</span>
                <span style="margin-left: 10px" v-else>{{ scope.row[item.param] }}</span>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column v-if="TableButtons.length > 0" label="操作" :width="TableButtonWidth">
          <template slot-scope="scope">
            <div style="text-align: center;">
              <el-button v-for="(item, index) in TableButtons" @click="tableButtonClick(scope.row,item.action,item)" :style="'padding:0;color:' + (item.color || '#409EFF')" :key="index" type="text">
                {{item.format ? item.format(scope.row) : item.name}}
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-row style="text-align: right;" v-if="PageSize <= total">
      <el-pagination @size-change="SizeChange" @current-change="pageChange" :current-page="PageIndex" :page-sizes="[10, 15, 20, 30]" :page-size="PageSize" layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
    </el-row>
    <!-- 表单 -->
    <el-dialog :title="pageHeader" :before-close="()=>{visible = false}" width="70%" append-to-body :visible.sync="visible">
      <el-form v-if="visible" class="formClass" :rules.sync="rules" ref="form" :model="model" label-width="100px">
        <div v-for="(item, index) in FormParams" :key="index">
          <el-form-item v-if="item.type != 'label'" :prop="item.param" :label="item.name">
            <form-item :type="item.type || 'text'" :form="item" :disabled="item.disabled || (item.isUpdate && isUpdate)" :value="model[item.param]" :select="selectOption[item.param] || []" :multiple="item.multiple || false" :checkType="item.checkType || 0" @valueChange="changeForm" :placeholder="item.placeholder"></form-item>
          </el-form-item>
          <el-form-item v-else>
            <p>{{item.name}}</p>
          </el-form-item>
        </div>
        <el-form-item>
          <el-button v-for="(item, index) in FormButtons" :key="index" :type="item.type || 'primary'" @click="formButtonClick(item.action)">{{item.name}}</el-button>
          <el-button @click="visible = false">取消</el-button>

        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 通讯录 -->
    <el-dialog title="通讯录" :visible="ShowMail" append-to-body width="70%" :before-close="()=>{ShowMail = false}">
      <Mail v-if="ShowMail" :MailSet.sync="MailSet" @SaveMail="MailAction" @Hide="()=>{ShowMail = false}"></Mail>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        TableData: [],
        PageIndex: 1,
        PageSize: 10,
        total: 0,
        Seach: {},
        model: {},
        selectOption: {},
        pageHeader: "添加",
        visible: false,
        rules: {},
        ShowMail: false,
        uploadAction: "",
        uploadHeader: {},
        isUpdate: false,
        MailSet: {
          type: 0,//类型0默认全部 1 部门 2 人员
          CheckType: 1,//选择类型 0单选 1多选
          CheckList: [],//已选人员
        }
      }
    },
    components: {
      FormItem: resolve => require(["@/components/System/components/FormItem"], resolve),
      Mail: resolve => require(["@/components/System/components/PcMail"], resolve),
    },
    props: {
      TopButtons: { type: Array, default () { return []; } },
      TopSeach: { type: Array, default () { return []; } },
      FormParams: { type: Array, default () { return []; } },
      TableColumns: { type: Array, required: true },
      TableButtons: { type: Array, default () { return []; } },
      TableButtonWidth: { type: String, default: "120px" },
      Controller: { type: String, required: true },
      GetAction: { type: String, default: "GetList" },
      SaveAction: { type: String, default: "AddOrUpdate" },
      DelAction: { type: String, default: "Delete" },
      DetailAction: { type: String, default: "GetDetails" },
      ExportAction: { type: String, default: "Export" },
      Order: { type: Object, default () { return { param: "", sort: false }; } },
      ShowBack: { type: Boolean, default: false },
      FormButtons: { type: Array, default () { return [{ name: "保存", action: "save" }]; } },
    },
    created () {
      //配置导入
      var data = JSON.parse(this.$tool.ss.Get(this.$config.LoginToken));
      this.uploadHeader = { Authorization: data.type + " " + data.token };
      this.uploadAction = this.Ajax.axios.defaults.baseURL + "/api/UpLoad/UploadFile";
      this.TopSeach.forEach(item => {
        if (item.type == "dateSpan") {
          this.Seach[item.param] = item.default || [];
        } else {
          this.Seach[item.param] = item.default || "";
        }
        if (item.type == "select") {
          this.GetSelectOption(item);
        }
      });
      this.FormParams.forEach(item => {
        if (item.type == "switch") {
          this.model[item.param] = item.default || false;
        } else {
          this.model[item.param] = item.default || "";
        }

        if (item.type == "select" && !this.selectOption[item.param]) {
          this.GetSelectOption(item);
        }
        if (item.required != false) {
          item.required = true;
          if (item.type != "switch") {
            if (item.validate) {
              this.rules[item.param] = [{ validator: item.validate, trigger: 'blur' }];
            } else {
              this.rules[item.param] = [{ validator: this.validatePass, trigger: 'blur' }];
            }
          }
        }
      });
    },
    mounted () {

      this.GetList();
    },
    methods: {
      GetList () {
        var data = {};
        for (const key in this.Seach) {
          data[key] = this.Seach[key];
        }

        if (this.Order.param) {
          data['order'] = this.Order.param;
          data['sort'] = this.Order.sort;
        }
        this.Ajax.Get("api/" + this.Controller + "/" + this.GetAction + "/" + this.PageIndex + "?pageSize=" + this.PageSize, data).then(res => {
          this.total = res.count;
          this.TableData = res.data;
        })
      },
      pageChange (index) {
        this.PageIndex = index;
        this.GetList();
      },
      SizeChange (size) {
        this.PageSize = size;
        this.GetList();
      },
      sortChange (sort) {
        this.Order.param = sort.prop;
        if (sort.order == "ascending")
          this.Order.sort = true;
        else
          this.Order.sort = false;
        this.GetList();
      },
      changeValue (param, value) {
        this.Seach[param] = value;
        this.GetList();
      },
      changeForm (param, value, form) {
        if (form.type == "mailList") {
          this.ShowMail = false;
          form.back(this.model, value)
        } else {
          this.model[param] = value;
        }
      },
      onSubmit () {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.Ajax.Post("api/" + this.Controller + "/" + this.SaveAction, this.model).then(res => {
              this.$tool.System.msg("操作成功", "提示", 0);
              this.visible = false;
              this.GetList();
            })
          }
        });

      },
      topButtonClick (type, item) {
        switch (type) {
          case "add":
            if (item.back) {
              item.back();
            }
            this.isUpdate = false;
            this.reloadModel();
            break;
          case "del":
            break;
          case "input":
            this.$emit("topButtonClick", type);
            break;
          case "user":
            this.MailSet = {
              type: item.checkType,//类型0默认全部 1 部门 2 人员
              CheckType: item.multiple ? 1 : 0,//选择类型 0单选 1多选
              CheckList: item.default || [],//已选人员
              TopDept: item.TopDept ? item.TopDept : 2
            };
            this.ShowMail = true;
            this.MailAction = item.back;
            break;
          case "export":
            var data = {};
            for (const key in this.Seach) {
              data[key] = this.Seach[key];
            }
            if (this.Order.param) {
              data['order'] = this.Order.param;
              data['sort'] = this.Order.sort;
            }
            this.Ajax.Get("api/" + this.Controller + "/" + this.ExportAction, data).then(res => {
              window.open(this.Ajax.axios.defaults.baseURL + res.data);
            })
            break;
          default:
            this.$emit("topButtonClick", type);
            break;
        }
      },
      formButtonClick (type) {
        if (type == "save") {
          this.onSubmit();
        } else {
          this.$refs.form.validate((valid) => {
            if (valid) {
              this.$emit("formButtonClick", type, this.model);
            }
          });
        }

      },
      tableButtonClick (row, type, item) {
        switch (type) {
          case "del":
            this.$tool.System.confim("是否删除该内容？").then(res => {
              this.Ajax.Post("api/" + this.Controller + "/" + this.DelAction + "/" + row.objectID).then(res => {
                this.$tool.System.msg("删除成功", "提示", 0);
                this.GetList();
              })
            }).catch(() => { });
            break;
          case "update":
            if (item.back) {
              item.back();
            }
            this.isUpdate = true;
            for (const key in row) {
              this.model[key] = row[key];
            }
            this.pageHeader = "修改";
            this.visible = true;
            break;
          case "user":
            this.$emit("tableButtonClick", row, type);
            this.MailSet = {
              type: item.checkType,//类型0默认全部 1 部门 2 人员
              CheckType: item.multiple ? 1 : 0,//选择类型 0单选 1多选
              CheckList: item.default,//已选人员
            };
            this.ShowMail = true;
            this.MailAction = item.back;
            break;
          default:
            this.$emit("tableButtonClick", row, type);
            break;
        }
      },
      validatePass (rule, value, callback) {
        if (this.model[rule.field] == '' || this.model[rule.field].length == 0) {
          callback(new Error("请填写完整信息"));
        } else {
          callback();
        }
      },
      MailAction (dt) { },
      reloadModel () {
        this.model = {};
        this.FormParams.forEach(item => {
          if (item.type == "switch") {
            this.model[item.param] = item.default || false;
          } else {
            this.model[item.param] = item.default || "";
          }
        });
        this.visible = true;
      },
      goBack () {
        this.$router.go(-1);
      },
      GetSelectOption (item) {
        if (item.select) {
          this.SetSelectOption(item.select, item.param);
        } else if (item.action) {
          this.Ajax.Get("api/Select/GetOption/" + item.action).then(res => {
            this.SetSelectOption(res.data, item.param);
          })
        }
      },
      SetSelectOption (data, param) {
        this.selectOption[param] = [];
        data.forEach(item => {
          if (item.label) {
            this.selectOption[param].push(item);
          } else {
            this.selectOption[param].push({
              label: item,
              value: item
            });
          }
        });
      }
    },
  }
</script>
<style scoped>
  * >>> .el-table th > .cell {
    text-align: center;
  }
  * >>> .el-drawer__body {
    overflow-y: auto;
  }
  .pad {
    padding-left: 20px;
    margin-bottom: 10px;
  }
  .lable {
    line-height: 40px;
    text-align: right;
  }
  .formClass {
    padding: 20px 10px 10px 10px;
  }
  .formClass >>> .el-button {
    margin-bottom: 10px !important;
  }
  .top-bottom {
    margin-right: 10px;
    float: left;
  }
</style>